export function addUrlSchemeIfNecessary(url: string): string {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
}

export function triggerBrowserDownload(url: string, filename: string): void {
  // Defer to the next paint. If the browser is zoomed in when this fires
  // synchronously inside a postMessage dispatch chain, Chrome leaves the
  // iframe with stale zoom/layout until the next reflow.
  requestAnimationFrame(() => {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
}
